import { render } from "./ImageGallery.vue?vue&type=template&id=1c316c12"
import script from "./ImageGallery.js?vue&type=script&lang=js"
export * from "./ImageGallery.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__